const POST_CLASS = {
    basic: 'PCL001',
    bold: 'PCL002',
    urgent: 'PCL003',
    pin: 'PCL004'
}

const POST_LABELS = [
    {value: '', name: '전체'},
    {value: 'PCA01', name: '공지'},
    {value: 'PCA02', name: '종합대행'},
    {value: 'PCA03', name: '블로그'},
    {value: 'PCA04', name: '플레이스'},
    {value: 'PCA05', name: '쇼핑'},
    {value: 'PCA06', name: '체험단'},
    {value: 'PCA07', name: 'SNS'},
    {value: 'PCA08', name: '카페'},
    {value: 'PCA09', name: '오프라인'},
    {value: 'PCA99', name: '기타'}
]

const OPTIONS_OF_POST_TYPE = {
    /* 대행 서비스 */
    PT001: {
        BASE_URL : '/consulting',
        CATEGORY_NAME : '마케팅 서비스',
        USE_CONTACT_INFO: true,
        USE_REACTION: false,
        USE_COMMENT: false,
        USE_ANNANYMOUS: false,
        IS_FREE: false,
        LABELS : POST_LABELS.slice(2),
        IS_ONLY_ADMIN: false
    },

    PT002: {
        BASE_URL : '/consulting',
        CATEGORY_NAME : '디자인 서비스',
        USE_CONTACT_INFO: false,
        USE_REACTION: false,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS : [],
        IS_ONLY_ADMIN: true
    },

    /* 질문 광장 */
    PT010: {
        BASE_URL : '/anon-community',
        CATEGORY_NAME : '익명 광장',
        CATEGORY_COLOR : 'color-green',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: true,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: false
    },
    PT011: {
        BASE_URL : '/free-community',
        CATEGORY_NAME : '자유 광장',
        CATEGORY_COLOR : 'color-blue',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: false
    },
    PT012: {
        BASE_URL : '/community',
        CATEGORY_NAME : '셀러 광장',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },

    /* 정보 광장장 */
    PT020: {
        BASE_URL : '/information',
        CATEGORY_NAME : '정보 공유',
        CATEGORY_COLOR : 'color-orange',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: false
    },
    PT021: {
        BASE_URL : '/information',
        CATEGORY_NAME : '셀러 정보 공유',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },

    /* 질문광장 */
    PT030: {
        BASE_URL : '/qna',
        CATEGORY_NAME : '질문 답변',
        CATEGORY_COLOR : 'color-purple',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: false
    },
    PT031: {
        BASE_URL : '/qna',
        CATEGORY_NAME : '셀러 질문 답변',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },

    /* 프로그램 */
    PT040: {
        BASE_URL : '/program',
        CATEGORY_NAME : '프로그램',
        CATEGORY_COLOR : 'color-red',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },

    /* 자유홍보광고 */
    PT050: {
        BASE_URL : '/openads',
        CATEGORY_NAME : '자유홍보광고',
        USE_CONTACT_INFO: true,
        USE_REACTION: false,
        USE_COMMENT: false,
        USE_ANNANYMOUS: false,
        IS_FREE: false,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },

    /* 공지 */
    PT060: {
        BASE_URL : '/notice',
        CATEGORY_NAME : '광장 공지',
        CATEGORY_COLOR : 'color-mint',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },
    PT061: {
        BASE_URL : '/notice',
        CATEGORY_NAME : 'N블로그 공지',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },
    PT062: {
        BASE_URL : '/notice',
        CATEGORY_NAME : 'N플레이스 공지',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },
    PT063: {
        BASE_URL : '/notice',
        CATEGORY_NAME : 'N통합검색 공지',
        USE_CONTACT_INFO: false,
        USE_REACTION: true,
        USE_COMMENT: true,
        USE_ANNANYMOUS: false,
        IS_FREE: true,
        LABELS: [],
        IS_ONLY_ADMIN: true
    },
}

const dataTypeTransform = post => {
    return typeof post === 'string' ? { post_type: post } : post;
}

const getPostType = post => {
    return typeof post === 'string' ? post : post.post_type;
}

const getPostBaseUrl = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].BASE_URL;
}

const getPostCategoryName = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)]?.CATEGORY_NAME || '';
}

const getPostCategoryColor = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)]?.CATEGORY_COLOR || '';
}

const getPostNicknm = post => {
    post = dataTypeTransform(post);
    return post.post_type !== 'PT010' ? post.user_nicknm : post.post_writer_nicknm;
}

const getPostLabels = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].LABELS;
}

const getPostLabelName = labelCd => {
    if (!labelCd) return;
    return POST_LABELS.filter(pl => pl.value === labelCd)[0].name;
}

const isUsingContactInfo = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].USE_CONTACT_INFO;
}

const isUsingReaction = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].USE_REACTION;
}

const isUsingComment = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].USE_COMMENT;
}

const isUsingAnnanymous = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].USE_ANNANYMOUS;
}

const isFree = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)].IS_FREE;
}

const isOnlyAdmin = post => {
    return OPTIONS_OF_POST_TYPE[getPostType(post)]?.IS_ONLY_ADMIN || false;
}

export { 
    POST_CLASS, OPTIONS_OF_POST_TYPE, POST_LABELS,
    getPostBaseUrl, getPostCategoryName, getPostCategoryColor, getPostNicknm, getPostLabels, getPostLabelName,
    isUsingContactInfo, isUsingReaction, isUsingComment, isUsingAnnanymous, isFree, isOnlyAdmin
};